import { c as _c } from "react/compiler-runtime";
import { Details } from '@cc-shopping/ui/primitives/Details';
import { Box, Typography } from '@mui/material';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
export type AccordionProps = StructuredContentDocumentWithRenderer<{
  label: string;
  labelCollapsed: string;
  initialStateExpanded: boolean;
  children: StructuredContentDocument;
}>;
export const AccordionItem = t0 => {
  const $ = _c(23);
  const {
    props: t1
  } = t0;
  const {
    label,
    children
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      paddingY: "12px"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== label) {
    t3 = <Typography variant="smallHeadline">{label}</Typography>;
    $[1] = label;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="mask-icon mask-icon-expand-more expand-icon" style={{
      width: "20px",
      height: "20px",
      backgroundColor: "currentColor"
    }} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <Box sx={t2}>{t3}{t4}</Box>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `panel-content-${label}`;
  const t7 = `panel-header-${label}`;
  const t8 = `panel-header-${label}`;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      paddingX: 2
    };
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t6 || $[8] !== t7 || $[9] !== t8) {
    t10 = {
      "data-testid": "accordion-summary",
      "aria-controls": t6,
      "aria-label": t7,
      id: t8,
      sx: t9
    };
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      "data-testid": "accordion-details",
      sx: {
        borderTop: "1px solid",
        borderColor: "neutral.lighter",
        "&:last-of-type": {
          borderBottom: "1px solid",
          borderColor: "neutral.lighter"
        },
        "&> summary:hover": {
          backgroundColor: "blues.lightest",
          outline: "2px solid",
          outlineColor: "blues.light",
          position: "relative",
          zIndex: 1
        }
      }
    };
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = `panel-content-${label}`;
  const t13 = `panel-header-${label}`;
  let t14;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      padding: 3
    };
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== children) {
    t15 = renderStructuredContent(children);
    $[13] = children;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  if ($[15] !== t12 || $[16] !== t13 || $[17] !== t15) {
    t16 = <Box id={t12} aria-labelledby={t13} sx={t14}>{t15}</Box>;
    $[15] = t12;
    $[16] = t13;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t10 || $[20] !== t16 || $[21] !== t5) {
    t17 = <Details variant="simple" SummaryComponent={t5} summaryComponentProps={t10} detailsProps={t11}>{t16}</Details>;
    $[19] = t10;
    $[20] = t16;
    $[21] = t5;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  return t17;
};